import { Tooltip, Button, Grid, IconButton } from "@mzc-pdc/ui";
import { IconCancel } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

export const PageHeader = ({ breadcrumb, prev, title, hideInfo, info, actions, sx }) => {
    const { t } = useTranslation();
    return (
        <>
            {breadcrumb}
            <Grid container flexDirection={"row"} flexWrap={"nowrap"} alignItems={"center"} sx={sx}>
                <Grid item xs mr={1} sx={{ overflow: "hidden", minWidth: 0 }}>
                    {/* 위 2 / 아래 16px 인 이유 — 이 행 위에는 `main` 의 `padding-top: 16px` 이 따로 있다.
                        행 안에서만 대칭으로 맞추면(8/8) 눈에 보이는 띠(앱바 밑줄 → 헤더 구분선) 기준으로는
                        위 31.3px · 아래 16.3px 로 위가 더 커 보인다(실측). 그 16px 을 여기서 상쇄해
                        타이틀이 띠 한가운데 놓이게 한다. */}
                    <Grid container mt={0.25} mb={2} flexWrap={"nowrap"} alignItems={"center"}>
                        {prev && (
                            <Grid item sx={{ maxHeight: "50px", mt: 1, flexShrink: 0 }}>
                                {prev}
                            </Grid>
                        )}
                        <Grid container alignItems={"center"} sx={{ flex: 1, overflow: "hidden", minWidth: 0 }}>
                            {title && (
                                <Grid item sx={{ flex: 1, overflow: "hidden", minWidth: 0 }}>
                                    {title}
                                </Grid>
                            )}
                            {prev && !hideInfo && !!info && (
                                <Button
                                    variant={"solid"}
                                    color={"primary"}
                                    sx={{ minWidth: 0, ml: 1.5, flexShrink: 0 }}
                                >
                                    {t(`common::label::Info`, `Info`)}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                {/* 액션 열도 타이틀 열과 같은 여백(위 2 / 아래 16)을 쓴다 — 그래야 둘이 같은 중심선에 놓인다.
                    이전에는 액션 열이 6/0 이라 ① 버튼(40px) 바닥이 헤더 구분선에 그대로 닿았고(실측 0px),
                    행 안에서만 8/8 로 맞췄더니 ② 버튼 중심이 타이틀보다 7px 아래로 내려갔다(실측).
                    원인은 둘 다 이 행 위에 있는 `main` 의 `padding-top: 16px` 이다 — 행 기준으로 맞추면
                    눈에 보이는 띠(앱바 밑줄 → 헤더 구분선) 기준으로는 어긋난다. */}
                <Grid item sx={{ mt: 0.25, mb: 2, minWidth: "fit-content", flexShrink: 0 }}>
                    {actions && (
                        <Grid item sx={{ minWidth: "fit-content", flexShrink: 0 }}>
                            {actions}
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export const CustomMenuPageHeader = ({ prev, title, hideInfo, info, actions, sx }) => {
    const { t } = useTranslation();
    const history = useHistory();
    return (
        <>
            <Grid container flexDirection={"row"} flexWrap={"nowrap"} sx={sx} px={3.5}>
                <Grid item xs mr={1} sx={{ overflow: "hidden", minWidth: 0 }}>
                    <Grid container my={"7px"} flexWrap={"nowrap"} alignItems={"stretch"}>
                        {prev && (
                            <Grid item sx={{ maxHeight: "40px", pt: "5px", flexShrink: 0 }}>
                                {prev}
                            </Grid>
                        )}
                        <Grid container alignItems={"center"} sx={{ flex: 1, overflow: "hidden", minWidth: 0 }}>
                            {title && (
                                <Grid item sx={{ flex: 1, overflow: "hidden", minWidth: 0 }}>
                                    {title}
                                </Grid>
                            )}
                            {prev && !hideInfo && !!info && (
                                <Button
                                    variant={"solid"}
                                    color={"primary"}
                                    sx={{ minWidth: 0, ml: 1.5, flexShrink: 0 }}
                                >
                                    {t(`common::label::Info`, `Info`)}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sx={{ display: "flex", py: 1.5, minWidth: "fit-content", flexShrink: 0 }}>
                    {actions && <Grid item>{actions}</Grid>}
                    <Tooltip title={t(`common::label::Close`, `Close`)}>
                        <IconButton
                            size="large"
                            circled
                            onClick={(e) => {
                                e.stopPropagation();
                                history.goBack();
                            }}
                            sx={{ ml: 1.5 }}
                        >
                            <IconCancel size={20} htmlColor={theme.palette.greySecondary.main} />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
        </>
    );
};
